import * as React from "react";
import { useCallback, useMemo } from "react";
import { stylesheet } from "typestyle";
import { CardReader } from "./CardReader.js";
import { PaymentError, usePayment } from "./hooks/payment.js";
import { useDeactivateListener, usePreventAutoDeactivate } from "./hooks/context.js";
import { classNames, toT } from "./utils.js";
import { layout } from "./layout.js";
import { PushButton } from "./PushButton.js";
import { View } from "./view.js";
export function PaymentView(props) {
    const { onCancel, strings, ...paymentOptions } = props;
    const t = toT(strings);
    const { processing, error, retry, canRetry, cancel, canCancel, message } = usePayment(paymentOptions);
    const handleDeactivate = useCallback(async () => {
        if (processing) {
            throw new Error("Cannot deactivate while payment is in progress.");
        }
    }, [processing]);
    useDeactivateListener(handleDeactivate);
    usePreventAutoDeactivate();
    const errorMessage = useMemo(() => {
        switch (error) {
            case PaymentError.Denied:
                return t("PaymentDenied");
            case PaymentError.Confirmation:
                return t("PaymentConfirmationFailed");
            case PaymentError.Vending:
                return t("VendFailed");
            case PaymentError.System:
                return t("PaymentSystemError");
        }
    }, [strings, error]);
    const handleCancelClick = useCallback(async () => {
        await cancel();
        onCancel();
    }, [cancel, onCancel]);
    return (React.createElement(View, null,
        React.createElement("div", { className: classNames(layout.fill, layout.vertical, layout.center, layout.alignCenter) },
            React.createElement(CardReader, { message: message, className: styles.cardReader })),
        React.createElement("div", { className: styles.cancelButton },
            React.createElement(PushButton, { onClick: handleCancelClick, disabled: !canCancel }, t("Cancel")),
            canRetry && (React.createElement(PushButton, { onClick: retry, primary: true, className: styles.retryButton }, t("RetryPayment")))),
        React.createElement("div", { className: styles.errorMessage, style: { visibility: errorMessage ? "visible" : "hidden" } }, errorMessage)));
}
const styles = stylesheet({
    cardReader: {
        fontSize: "1.25em",
        width: "80%"
    },
    cancelButton: {
        position: "absolute",
        left: "2.5em",
        bottom: "1.5em",
    },
    retryButton: {
        marginLeft: "1em",
    },
    errorMessage: {
        position: "absolute",
        right: 0,
        bottom: "1.5em",
        backgroundColor: "var(--color-error)",
        padding: "0.75em 3em 0.75em 1.5em",
        width: "22em",
    },
});
//# sourceMappingURL=PaymentView.js.map